import templateStr from 'text!./templates/ctrl-group.html';

var inputId = 0;

export default (function () {
    return {
        require: ['?^form', '?^ngForm'],
        transclude: true,
        scope: {
            label: '@?',
            subLabel: '@?',
            readonly: '=?',
            model: '=',
            currency: '@',
            flavor: '@',
            hideInputLabel: '<?',
            explicitErrorMessage: '@?',
            validity: '=?'
        },
        template: templateStr,

        controller: ['$scope', '$timeout', 'StateUtils', 'EventHub', function ($scope, $timeout, StateUtils, EventHub) {
            if (!$scope.model) {
                throw new Error('Input with label "' + $scope.label + '" has an undefined model scope value');
            }

            $scope.pristine = true;
            // once a different value is set on the model then we mark the field as not pristine
            $scope.$watch('model.value', function (newValue, oldValue) {
                $scope.pristine = !$scope.pristine ? false : newValue === oldValue;
            });

            $scope.$timeout = $timeout;
            $scope.StateUtils = StateUtils;
            $scope.EventHub = EventHub;
        }],

        link: function link(scope, element, attrs, ctrls) {
            var parentForm = ctrls[0];

            if (parentForm && !parentForm.invalidInputs) {
                parentForm.invalidInputs = []; // The IDs of invalid inputs, used to $anchorScroll to correct element
            }
            var validityFn = function validityFn() {
                // If the model is a coverage term, use the coveragePublicID property
                var publicID = scope.model.coveragePublicID ? scope.model.coveragePublicID : scope.model.publicID;
                if (!scope.model.aspects.valid && parentForm && parentForm.invalidInputs && !parentForm.invalidInputs.includes(publicID)) {
                    parentForm.invalidInputs.push(publicID);
                } else if (scope.model.aspects.valid) {
                    removeInvalidInput(publicID);
                }

                return scope.model.aspects.valid;
            };

            function removeInvalidInput(publicID) {
                if (parentForm && parentForm.invalidInputs.includes(publicID)) {
                    var i = parentForm.invalidInputs.indexOf(publicID);
                    parentForm.invalidInputs.splice(i, 1);
                }
            }

            var setPristineFn = function setPristineFn() {
                // we need to use this postDigest function here because the
                // watch on 'model.value' in the controller gets called after
                // this function is called even though the model was changed first
                scope.$$postDigest(function () {
                    scope.pristine = true;
                    scope.$apply();
                });
            };
            if (parentForm) {
                var removeListenerFn = parentForm.addModelControl(validityFn, setPristineFn);
                scope.$on('$destroy', function () {
                    removeInvalidInput();
                    return removeListenerFn();
                });
            }

            if (!('readonly' in scope) && attrs.readonly === '') {
                // if readonly attr exists with no value then set it to true
                scope.readonly = true;
            }
            scope.isVisible = function () {
                return !('visible' in scope.model.aspects) || scope.model.aspects.visible;
            };

            scope.inputId = inputId++;

            scope.showError = function () {
                var formHasBeenSubmitted = parentForm ? parentForm.submitted : true;
                if (!scope.model.aspects.valid && !scope.pristine || !scope.model.aspects.valid && formHasBeenSubmitted || scope.validity !== undefined && !scope.validity) {
                    return true;
                }
            };

            element.on('focusin', function () {
                scope.focused = true;
                scope.$apply();
            });

            element.on('focusout', function () {
                scope.focused = false;
                var path = scope.StateUtils.getTrackingUrl();
                var field = scope.label;

                // Wrap apply in timeout function so that it can safely run in the next digest cycle
                scope.$timeout(function () {
                    return scope.$apply();
                });
                scope.EventHub.publish('fieldTracking', 'fieldTracking', {
                    path: path, fieldName: field
                });
            });

            scope.drawSubLabel = function (label) {
                if (typeof label != "undefined") return '<sub>' + label + '</sub>';
            };
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/basicinputs/CtrlGroupDirective.js
// module id = 100
// module chunks = 0